import { Component } from "preact";
import { Link } from "preact-router/match";
import styled from "styled-components";

class Footer extends Component {
  scrollToId = (id) => {
    let element = document.getElementById(id);
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      language: null,
    };
  }

  render() {
    const FooterContainer = styled.div`
      background: ${this.context.colors.primary};
      box-sizing: border-box;
      min-height: 24.5rem;
      padding-bottom: 2rem;
      padding-top: 5.5rem;
      @media only screen and (max-width: 1200px) {
        padding-top: 4rem;
      }
      @media only screen and (max-width: 680px) {
        min-height: auto;
      }
      .wrapper {
        display: flex;
        margin: 0 auto;
        max-width: 120rem;
        width: 100%;
        @media only screen and (max-width: 1200px) {
          align-items: center;
          flex-direction: column;
          justify-content: center;
        }
        .studio-ad {
          max-width: 62rem;
          img {
            height: auto;
            max-height: 22.5rem;
            max-width: 15.5rem;
            width: 100%;
            @media only screen and (max-width: 680px) {
              display: none;
            }
          }
          p {
            align-items: center;
            display: flex;
            font-size: 1rem;
            justify-content: center;
            line-height: 3;
            color: ${this.context.colors.link};
            margin: 0 0 0 3.2rem;
            max-width: 36rem;
            width: 100%;
            @media only screen and (max-width: 680px) {
              text-align: center;
              line-height: 2;
              margin: 0;
              padding: 0 2rem 5rem 2rem;
            }
          }
        }
      }
      .ga-film {
        align-items: center;
        display: flex;
        gap: 1rem;
        margin-bottom: 2rem;
        &-disclaimer {
          color: #ffffff;
          font-size: 1.1rem;
          width: 85%;
        }
        img {
          width: 3rem;
        }
      }
      .legal {
        margin: 2rem 0 1rem;
        border-top: 0.1rem solid rgba(255, 255, 255, 0.25);
        padding-top: 2rem;
        color: ${this.context.colors.link};
        font-size: 1.1rem;
      }
      .legal-links {
        a {
          text-transform: initial;
        }
      }
      .links-wrapper {
        margin-left: auto;
        max-width: 70rem;
        @media only screen and (max-width: 1200px) {
          margin-bottom: 4rem;
          margin-left: initial;
          order: -1;
          padding: 0 2rem;
        }
        a {
          color: #ffffff;
          cursor: pointer;
          font-size: 1.2rem;
          text-decoration: none;
          text-transform: uppercase;
          &:not(:last-of-type) {
            margin-right: 5rem;
          }
          &:hover {
            color: ${this.context.colors.hoverLink};
          }
        }
      }
    `;

    return (
      <FooterContainer>
        <div className="wrapper">
          <div className="studio-ad">
            <img src={this.context.branding.logoLarge} alt={this.context.copy.longName} />
            {this.context.copy.footerCopy && <p>{this.context.copy.footerCopy}</p>}
          </div>
          <div className="links-wrapper">
            <Link activeClassName="active" onClick={() => this.scrollToId("careers")}>
              Careers
            </Link>
            <Link activeClassName="active" onClick={() => this.scrollToId("studio")}>
              About
            </Link>
            <a activeClassName="active" href="mailto:evilmojogames@hirezstudios.com">
              Contact
            </a>
            <a activeClassName="active" href="https://store.epicgames.com/en-US/p/paladins" target="_blank">
              Play Paladins
            </a>
            <a
              activeClassName="active"
              href="https://store.epicgames.com/en-US/p/realm-royale-reforged"
              target="_blank"
            >
              Play Realm Royale
            </a>
            <div className="legal">
              © 2018 Hi-Rez Studios, Inc. "Paladins", "Champions of the Realm", "Evil Mojo Games", and "Hi-Rez Studios"
              are trademarks or registered trademarks of Hi-Rez Studios, Inc. in the U.S. and/or other countries. All
              trademarks and copyright material are property of their respective owners. All rights reserved.
            </div>
            <div className="ga-film">
              <a href="https://georgia.org/film" target="_blank">
                <img src="https://webcdn.hirezstudios.com/studios/peach-2024.png" alt="Georgia Film" />
              </a>
              <p className="ga-film-disclaimer">
                This project was completed with assistance from the Georgia Film Office, a division of the Georgia
                Department of Economic Development
              </p>
            </div>
            <div className="legal-links">
              <a activeClassName="active" target="_blank" href="https://www.hirezstudios.com/privacypolicy">
                Privacy Policy
              </a>
              <a
                activeClassName="active"
                target="_blank"
                href="https://webcdn.hirezstudios.com/hirez-studios//wp-content/uploads/2015/11/Hi-Rez-Studios-Terms-of-Service-and-Use-Agreement-7-12-2018.pdf"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </FooterContainer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer.js